import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import SyncSegmentsForm from '../../components/SyncSegments/SyncSegmentsForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['syncSegments']}`;

const SyncSegmentsDetailsPage = () => {
  const { accountId, domainId, segmentSyncId } = useParams();
  const fetch = useFetch();
  const [segmentSync, setSegmentSync] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segmentSyncs/${segmentSyncId}`)
      .then(({ segmentSync }) => {
        setSegmentSync(segmentSync);
      })
      .catch((err) => {
        setError(err.message || 'Failed to load segment sync');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [fetch, accountId, domainId, segmentSyncId]);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (!segmentSync) {
    return <ErrorMessage message="Segment sync not found" />;
  }

  const breadcrumbItems = [
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/syncSegments` },
    { title: segmentSync.name },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | ${segmentSync.name}`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <SyncSegmentsForm segmentSync={segmentSync} />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default SyncSegmentsDetailsPage;
